// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#main,.table-multiple{border-radius:5px}.table-multiple{overflow-x:scroll}", ""]);
// Exports
module.exports = exports;
